export const SITE_NAME = 'Genealogy Packs';
export const SITE_TAGLINE = 'Family tree templates, charts, posters & custom design';
export const SITE_DOMAIN = 'genealogypacks.online';
export const SITE_URL = 'https://www.genealogypacks.online';

export const SUPPORT_EMAIL = 'support@genealogypacks.online';

export const POLICY_UPDATED = 'August 4, 2026';
